/** 命中名单的请求，在 header 里带上当前车辆 id */
export const TERRAROBO_DEVICE_ID_HEADER = 'terrarobo-device-id'

const needHeaderUrlList = [
  // 任务
  {
    url: '/api/v3/tasks',
    method: 'post',
  },
  {
    url: '/api/v3/tasks/:id/init',
    method: 'post',
  },
  {
    url: '/api/v3/tasks/:id/actions/:action',
    method: 'post',
  },
  // 多任务
  {
    url: '/api/v3/multi-tasks',
    method: 'post',
  },
  {
    url: '/api/v3/multi-tasks/:multiTaskId/actions/:action',
    method: 'post',
  },
  // 设备操作
  {
    url: '/api/v3/devices',
    method: 'put',
  },
  {
    url: '/api/v3/devices/extraInfo',
    method: 'post',
  },
  {
    url: '/api/v3/devices/:deviceid',
    method: 'get',
  },
  {
    url: '/api/v3/devices/:deviceid/gps',
    method: 'get',
  },
  {
    url: '/api/v3/devices/:deviceid/rollback-tmp',
    method: 'post',
  },
  {
    url: '/api/v3/devices/:deviceid/fence/:action',
    method: 'post',
  },
  {
    url: '/api/v3/devices/:deviceid/mowing/start',
    method: 'post',
  },
  {
    url: '/api/v3/devices/:deviceid/mowing/stop',
    method: 'post',
  },
  {
    url: '/api/v3/devices/high-precision-gps',
    method: 'post',
  },
  {
    url: '/api/v3/devices/high-precision-gps/finish',
    method: 'post',
  },
  {
    url: '/api/v3/devices/req-resources-data',
    method: 'post',
  },
  {
    url: '/api/v3/devices/upgrade',
    method: 'post',
  },
  {
    url: '/api/v3/devices/:deviceid/maps/download',
    method: 'post',
  },
  {
    url: '/api/v3/devices/:deviceid/logs/remote-browse-req',
    method: 'post',
  },
  {
    url: '/api/v3/devices/:deviceid/logs/remote-upload-req',
    method: 'post',
  },
  {
    url: '/api/v3/robot/:deviceid/logs/remote-browse-res',
    method: 'post',
  },
  {
    url: '/api/v3/workspaces/zones/start',
    method: 'post',
  },
  {
    url: '/api/v3/workspaces/zones/cancel',
    method: 'post',
  },
  {
    url: '/api/v3/workspaces/zones/finish',
    method: 'post',
  },
  {
    url: '/api/v3/workspaces/upload-map',
    method: 'post',
  },
  {
    url: '/api/v3/workspaces/recommend-path',
    method: 'post',
  },
  {
    url: '/api/v3/evchargers',
    method: 'post',
  },
  {
    url: '/api/v3/evchargers',
    method: 'get',
  },
  {
    url: '/api/v3/evchargers/nearby-workspace-charger',
    method: 'get',
  },
  {
    url: '/api/v3/base/nearby-workspace-charger',
    method: 'get',
  },
  {
    url: '/api/v3/latestpkgs/notify',
    method: 'post',
  },
  {
    url: '/api/v3/latestpkgs/notify2upgrade',
    method: 'post',
  },
  {
    url: '/api/v3/latestpkgs/notify2download',
    method: 'post',
  },
  {
    url: '/api/v3/latestpkgs/notify2install',
    method: 'post',
  },
  {
    url: '/api/v3/latestpkgs/progress',
    method: 'post',
  },
  {
    url: '/api/v3/latestpkgs/installed',
    method: 'post',
  },
  {
    url: '/api/v3/latestpkgs/down',
    method: 'get',
  },
  {
    url: '/api/v3/latestpkgs/down2',
    method: 'get',
  },
  {
    url: '/api/v3/latestpkgs/rollback',
    method: 'get',
  },
  {
    url: '/api/v3/sites/:siteId/generate-network',
    method: 'post',
  },
]

function stripAfter(value, mark) {
  const index = value.indexOf(mark)
  return index >= 0 ? value.slice(0, index) : value
}

/** 去掉域名、query、hash，得到以 /api 开头的路径 */
function toRequestPath(url) {
  let path = stripAfter(stripAfter(String(url || ''), '#'), '?')
  const protocolIndex = path.indexOf('://')
  if (protocolIndex >= 0) {
    const slashIndex = path.indexOf('/', protocolIndex + 3)
    path = slashIndex >= 0 ? path.slice(slashIndex) : ''
  }
  if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1)
  return path
}

/** 冒号开头的片段匹配单个路径段，其余段必须完全一致 */
function matchPath(pattern, pathname) {
  const patternParts = String(pattern || '').split('/').filter(Boolean)
  const pathParts = String(pathname || '').split('/').filter(Boolean)
  if (patternParts.length !== pathParts.length) return false
  return patternParts.every((token, index) => {
    if (token.charAt(0) === ':') return pathParts[index].length > 0
    return token === pathParts[index]
  })
}

function findMatchedHeaderRule(url, method) {
  const path = toRequestPath(url)
  const normalizedMethod = String(method || 'GET').toLowerCase()
  const matched = needHeaderUrlList.find((item) => item.method === normalizedMethod && matchPath(item.url, path))
  return matched ? { rule: matched, path } : null
}

export function shouldAttachDeviceHeader(url, method) {
  return findMatchedHeaderRule(url, method) != null
}

/** 从命中规则的 :deviceid 段取出车辆 id，例如 /devices/xxx/maps/download */
function deviceIdFromMatchedPath(rule, path) {
  const patternParts = String(rule.url || '').split('/').filter(Boolean)
  const pathParts = String(path || '').split('/').filter(Boolean)
  const index = patternParts.indexOf(':deviceid')
  if (index < 0 || index >= pathParts.length) return ''
  try {
    return decodeURIComponent(pathParts[index]).trim()
  } catch {
    return String(pathParts[index] || '').trim()
  }
}

/** Web 没有设备 store，当前车辆在页面地址上：多数页面是 deviceId，详情和升级页是 id */
const DEVICE_ID_QUERY_PATHS = ['/devices/detail', '/device/upgrade']

export function getCurrentDeviceId() {
  if (typeof window === 'undefined') return ''
  const params = new URLSearchParams(window.location.search)
  const deviceId = String(params.get('deviceId') || '').trim()
  if (deviceId) return deviceId
  if (!DEVICE_ID_QUERY_PATHS.includes(window.location.pathname)) return ''
  return String(params.get('id') || '').trim()
}

function readHeader(headers, name) {
  if (!headers) return ''
  if (typeof headers.get === 'function') {
    return headers.get(name)
  }
  return headers[name]
}

function deviceIdFromPayload(value) {
  if (!value) return ''
  if (typeof value === 'string') {
    try {
      return deviceIdFromPayload(JSON.parse(value))
    } catch {
      return ''
    }
  }
  if (typeof value !== 'object') return ''
  if (typeof value.get === 'function') {
    return String(value.get('deviceId') || '').trim()
  }
  return String(value.deviceId || '').trim()
}

/** 请求体或 query 里的 deviceId，例如 generate-network */
function deviceIdFromRequest(config) {
  return deviceIdFromPayload(config?.data) || deviceIdFromPayload(config?.params)
}

/** 名单内的请求写入 terrarobo_device_id。已传入时不覆盖；没有车辆 id 时不写空值。 */
export function applyTerraroboDeviceHeader(config) {
  if (!config || !config.url) return
  const matched = findMatchedHeaderRule(config.url, config.method)
  if (!matched) return
  // 路径 :deviceid 优先；否则用页面上的当前车；再否则用请求体里的 deviceId
  const deviceId = deviceIdFromMatchedPath(matched.rule, matched.path) || getCurrentDeviceId() || deviceIdFromRequest(config)
  if (!deviceId) return
  if (!config.headers) config.headers = {}
  const current = readHeader(config.headers, TERRAROBO_DEVICE_ID_HEADER)
  if (current != null && String(current).trim() !== '') return
  if (typeof config.headers.set === 'function') {
    config.headers.set(TERRAROBO_DEVICE_ID_HEADER, deviceId)
    return
  }
  config.headers[TERRAROBO_DEVICE_ID_HEADER] = deviceId
}
